import React from 'react';
import Reflux from 'reflux';
import {hashHistory} from 'react-router';
import {message, Button} from 'antd';
import {DmsTab} from 'Components';
import {fetchQuestionSort} from '../../service/survey';
import {exportString} from '../../service/survey';
import './survey.css';

class SurveyResult extends Reflux.Component {
    constructor(props) {
        super(props);
        this.state = {
            opts: ['问卷结果'],
            surveyId: this.props.params.surveyId,
            resultQuestion: [],
			resultAnswer: []
        };
    }

    componentWillMount() {
    }

    componentDidMount(){
        this.getData();
    }

    getData = () => {
        fetchQuestionSort({businessId: this.state.surveyId}).then(result => {
            if (result.status && result.code == 200) {
                this.setState({
                    resultQuestion: result.question,
					resultAnswer: result.answer
                });
            } else {
                message.error(result.message);
            }
        });
    }

    //页面跳转
    goView = (url) => {
        hashHistory.push(url);
    }

    exportFn = () => {
    	window.open(exportString({businessId: this.state.surveyId}));
    }

    render() {
        var self = this;
        const {opts} = this.state;

        var questionArr = self.state.resultQuestion || [];
        var ids = ['name'];
		var questionHtml = questionArr.map(function (qst, key) {
			ids.push(qst.id);
			return (
				<th className="sorting" key={key}>{qst.sortOrder}</th>
			);
		});
		var answerArr = self.state.resultAnswer || [];
		var answerHtml = answerArr.map(function (qst, key) {
			var tdHtml = ids.map(function (q, k) {
				return (
					<td key={k} className="sorting_1">{qst[q]}</td>
				);
			});
			return <tr key={key}>
				{tdHtml}
			</tr>
		});

        return (
            <div className='dms-body'>
                <div>
                    <DmsTab options={opts} defaultKey={0}>
                        <Button onClick={this.exportFn}>导出</Button>
                    </DmsTab>
                </div>

                <div className="dms-table-box">
                    <table className="table table-striped table-hover table-bordered dataTable no-footer"
						style={{marginBottom: '40px'}}>
						<thead>
						<tr role="row">
							<th className="sorting">调研对象</th>
							{questionHtml}
						</tr>
						</thead>
						<tbody className="public-body">
							{answerHtml}
						</tbody>
					</table>
                </div>
            </div>
        )
    }
};
export default SurveyResult;


// WEBPACK FOOTER //
// ./src/routes/survey/result.js